function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import times from 'lodash/times';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

var LoadingCard = function LoadingCard() {
  return React.createElement("div", {
    className: "loading-card"
  }, React.createElement("div", {
    className: "loading-card__item loading-card__main"
  }), React.createElement("div", {
    className: "loading-card__aside"
  }, React.createElement("div", {
    className: "loading-card__item loading-card__item-0"
  }), React.createElement("div", {
    className: "loading-card__item loading-card__item-1"
  }), React.createElement("div", {
    className: "loading-card__item loading-card__item-2"
  }), React.createElement("div", {
    className: "loading-card__item loading-card__item-3"
  })));
};

var _getDeclaredCards = function _getDeclaredCards(cardCount) {
  return times(cardCount, function (index) {
    return React.createElement(LoadingCard, {
      key: "loading-card-".concat(index)
    });
  });
};
/*
* Rough implementation of a configurable loading state component for
* event style cards on search experiences. Currently structured to support
* a single column of cards of variable counts and styles.
*/


var LoadingCards =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LoadingCards, _PureComponent);

  function LoadingCards() {
    _classCallCheck(this, LoadingCards);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingCards).apply(this, arguments));
  }

  _createClass(LoadingCards, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          cardCount = _this$props.cardCount;

      var cards = _getDeclaredCards(cardCount);

      return React.createElement("section", {
        className: "loading-cards__container loading-cards--".concat(style, " eds-l-pad-top-6 eds-l-pad-hor-6")
      }, cards);
    }
  }]);

  return LoadingCards;
}(PureComponent);

_defineProperty(LoadingCards, "propTypes", {
  /*
  * Determines loading card style to display
  * list, grid
  */
  style: PropTypes.oneOf(['list', 'grid', 'list-square']),

  /*
  * The number of cards to be rendered
  */
  cardCount: PropTypes.number
});

_defineProperty(LoadingCards, "defaultProps", {
  style: 'list',
  cardCount: 5
});

export { LoadingCards as default };